import {HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {environment} from '@environments/environment';
import {catchError, switchMap, throwError} from 'rxjs';
import {GenericAuthService} from './generic-auth/generic-auth.service';
import {UserType} from './generic-auth/user-type.enum';

const generateRoutesWithoutBearerToken = (segment: string): string[] => [
    `${segment}/login`,
    `${segment}/new-password`,
    `${segment}/refresh-token`,
    `${segment}/signup`
];

const routesWithoutBearerToken = [
    'admin/check-email',
    'admin/account-activation',
    ...generateRoutesWithoutBearerToken(UserType.ADMIN),
    ...generateRoutesWithoutBearerToken(UserType.OWNER),
    ...generateRoutesWithoutBearerToken(UserType.CLINICIAN),
    'timeline'
];

export const interceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) =>
{
    if (request.url.includes('assets'))
    {
        return next(request);
    }

    const genericAuthService = inject(GenericAuthService);

    const userType = genericAuthService.getUserTypeFromApiRequest(window.location.href, request.url);
    const accessToken = genericAuthService.getAccessToken(userType);

    const requestClone = request.clone({
        url: `${environment.apiURL}/${request.url}`,
        ...accessToken?.length > 1 ? {headers: request.headers.set('Authorization', `Bearer ${accessToken}`)} : {}
    });

    return next(requestClone).pipe(catchError((error) =>
    {
        if (
            error.error.statusCode !== 401 ||
            routesWithoutBearerToken.some((endpoint: string) => requestClone.url.includes(endpoint))
        )
        {
            return throwError(() => error);
        }

        return genericAuthService.refreshAccessToken(userType).pipe(
            switchMap(() =>
            {
                const requestToRetry = requestClone.clone({
                    headers: requestClone.headers.set('Authorization', `Bearer ${genericAuthService.getAccessToken(userType)}`)
                });

                return next(requestToRetry);
            })
        );
    }));
};
